import styled from 'styled-components';
import { useState, useEffect } from 'react';
import { useUser } from '../utils/UserContext';
import { Link, Navigate } from 'react-router-dom';
import Footer from '../components/Footer';
import AddFriend from '../assets/add-friend.png';
import AquaGem from '../assets/aquaGem.png';
import EarnStar from '../assets/earnStar.png';
import axios from 'axios';
import AddFriendA from '../assets/friends.png';
import COPIEDICON from '../assets/notes.png';
import { motion } from "framer-motion";
import { useNavigate } from 'react-router-dom';



const Container = styled.div`
    width: 100%;
    height: 100vh;
    background: #060514;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
    font-family: Space Grotesk;

`;

const RadialGradient = styled.div`
    position: absolute;
    top: -25%;
    right: -25%;
    width: 400px;
    height: 400px;
    background: radial-gradient(circle at center, rgba(120, 3, 255, 0.2), #060514, #060514);
    background-size: cover;
    z-index: 1;
    `;

const RadialGradientB = styled.div`
    position: absolute;
    top: 35%;
    right: 0px;
    width: 300px;
    height: 300px;
    background: radial-gradient(circle at center, rgba(120, 3, 255, 0.2), #060514, #060514);
    background-size: cover;
    z-index: 1;
    `;

const RadialGradientA = styled.div`
    position: absolute;
    bottom: -25%;
    left: -25%;
    width: 400px;
    height: 400px;
    background: radial-gradient(circle at center, rgba(120, 3, 255, 0.2), #060514, #060514);
    background-size: cover;
    z-index: 1;
    `;


const HeroSection = styled.div`
    width: 100%;
    text-align: center;
    color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 2;
`;

const Title = styled.div`
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 20px;
    font-family: Space Grotesk, Sans Serif;
    color: white;
    margin-top: 15px;
`;

const Subtitle = styled.div`
    font-size: 12px;
    color: #c1cade;
    font-weight: 600;
    font-family: Space Grotesk, Sans Serif;
`;

const IconWrapper = styled.div`
    width: 150px;
    height: 150px;
    background: linear-gradient(145deg, rgba(0, 220, 255, 0.2), rgba(0, 220, 255, 0.7));
    box-shadow: 0px 0px 30px rgba(0, 220, 255, 0.5);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
`;

const GenerateSection = styled.div`
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    z-index: 2;
`;

const StyledButton = styled.button`
    padding: 15px 30px;
    font-size: 1rem;
    font-weight: bold;
    width: 90%;
    border-radius: 50px;
    background: linear-gradient(to bottom right, #007acc, #007acc, #66b2ff); 
    backdrop-filter: blur(10px); // Glass effect
    border: 1px solid #007acc;    
    color: white;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-top: 20px;
    font-family: Space Grotesk, Sans Serif;

    &:hover {
        transform: scale(1.05);
        box-shadow: 0 0 20px rgba(0, 220, 255, 0.8);
    }
`;

const SubTitleRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: center;
    margin-bottom: 30px;
    `
const GemWrapper = styled.img`
    width: 15px;
    height: 15px;
    object-fit: contain;
    margin: 0px 5px 0px 5px;
    `
const FriendWrapper = styled.img`
    width: 15px;
    height: 15px;
    object-fit: contain;
    margin: 0px 15px 0px 5px;
    `

const StyledButtonA = styled.button`
    padding: 15px 30px;
    font-size: 1rem;
    font-weight: bold;
    width: 90%;
    border-radius: 50px;
    background: #007acc;
    backdrop-filter: blur(10px); // Glass effect
    border: 1px solid rgba(255, 255, 255, 0.2);    
    color: white;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-top: 20px;
    font-family: Space Grotesk, Sans Serif;

    &:hover {
        transform: scale(1.05);
        box-shadow: 0 0 20px rgba(0, 220, 255, 0.8);
    }
`;

const IconImage = styled.img`
    margin: 20px 0px;
    `
const ImageWrapper = {
    position: 'absolute',
    bottom: '0', 
    left: '0',
    width: '100%',
};

const TitleRow = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '75%',
    
};

const SectionTitle = {
    fontSize: '18px',
    color: 'white',
    fontWeight: '600',
    zIndex: '999',
    marginLeft: '10px',
};

const InviteInfo = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '70%',
    padding: '20px',
    border: '1px solid rgba(0, 122, 204, 0.5)',
    backgroundColor: 'rgba(0, 122, 204, 0.05)', 
    borderRadius: '15px',
    marginTop: '10px',
    marginBottom: '20px',
    boxShadow: '0 5px 10px rgba(0, 0, 0, 0.5)',

};

const InviteInfoA = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '70%',
    padding: '20px',
    border: '1px solid rgba(0, 122, 204, 0.5)',
    backgroundColor: 'transparent', 
    borderRadius: '15px',
    marginTop: '10px',
    boxShadow: '0 5px 10px rgba(0, 0, 0, 0.5)',

};

const ModalTopTitle = styled.div`
    color: rgba(0, 0, 0, 0.95);
    font-size: 20px;
    font-weight: 600;
    width: 80%;
    text-align: center;
    margin-bottom: 20px;
    `

const InviteInfoRow = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
};

const InviteInfoRowA = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
};

const RewardWrapperBigText = {
    fontSize: '13px',
    color: '#dfe6f0',
    fontWeight: '500',
    textAlign: 'left',
};

const ButtonRow = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
};

const ButtonC = {
    padding: '7.5px 0px',
    background: '#007acc', 
    borderRadius: '10px',
    width: '100%',
    border: '2px solid #007acc',
    cursor: 'pointer',
    transition: 'transform 0.3s ease, background-color 0.3s ease',
    textAlign: 'center',
    boxShadow: '0 5px 10px rgba(0, 0, 0, 0.5)',
    marginTop: '20px',
    textDecoration: 'none',
    ':hover': {
        backgroundColor: '#444444',
        transform: 'scale(1.05)',
    },
};

const ButtonD = {
    padding: '7.5px 0px',
    borderRadius: '10px',
    width: '100%',
    background: 'transparent',
    border: '2px solid #007acc',
    cursor: 'pointer',
    transition: 'transform 0.3s ease, background-color 0.3s ease',
    textAlign: 'center',
    boxShadow: '0 5px 10px rgba(0, 0, 0, 0.5)',
    marginTop: '20px',
    textDecoration: 'none',
    ':hover': {
        backgroundColor: '#444444',
        transform: 'scale(1.05)',
    },
};

const ButtonTextC = {
    fontSize: '13px',
    color: 'white',
    fontWeight: '600',
    lineHeight: '1.6',
};

const Invite = () => {
    const { user } = useUser();
    const [userInviteLink, setUserInviteLink] = useState(null);
    const [isModalOpen, setModalOpen] = useState(false);
    const [userData, setUserData] = useState(null);
    const [error, setError] = useState(null);
    const teamSize = userData && userData.team;
    const teamRewards = userData && userData.team_rewards;
    const navigate = useNavigate();

    const handleGenerateLink = () => {
        const botUsername = "HydrixGemsBot";
        const inviteLink = `https://t.me/${botUsername}?start=${user.id}`;
        navigator.clipboard.writeText(inviteLink).then(() => {
            setUserInviteLink(inviteLink);
            setModalOpen(true);
        });
    };

    const fetchUserData = async () => {
        try {
            const response = await axios.get(`https://chainfree.info:5000/user`);
            setUserData(response.data.userData);
            console.log('userData', response.data.userData);
            setError(null); 
        } catch (error) {
            setError(error.message);
        }
    };

    useEffect(() => {
        fetchUserData();
      }, []);
    
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const goToHome = () => {
    setTimeout(() => {
        navigate("/")
    }, 500);
}

const goToEarn = () => {
    setTimeout(() => {
        navigate("/earn")
    }, 500);
}

    return (
        <Container>
            <RadialGradient />
            <RadialGradientA />
            <RadialGradientB />
            <HeroSection>
                <Title>Invite Your Friends</Title>
                <SubTitleRow>
                    <Subtitle>Earn</Subtitle>
                        <GemWrapper src={AquaGem} />
                    <Subtitle>For inviting friends & family!</Subtitle>
                </SubTitleRow>
                
            <div style={TitleRow}>
                <img src={EarnStar} />
                <div style={SectionTitle}>Invite Rewards</div>
            </div>
            <div style={InviteInfo}>
                <div style={ InviteInfoRow }>
                    <FriendWrapper src={AquaGem} />
                    <div style={RewardWrapperBigText}>You have earnt {userData && teamRewards != null ? teamRewards.toFixed(0) : "?"} Gems
                        from invites!
                    </div>
                </div>
                <div style={ButtonRow}>
                    <button onClick={goToEarn} style={ButtonC}>
                        <div style={ButtonTextC}>Extra Rewards</div>
                    </button>
                </div>
                <div style={ButtonRow}>
                    <button onClick={goToHome} style={ButtonD}>
                        <div style={ButtonTextC}>Mine</div>
                    </button>
                </div>
            </div>   
            <div style={TitleRow}>
                <img src={EarnStar} />
                <div style={SectionTitle}>Invite</div>
            </div>   
            <div style={InviteInfoA}>
                <div style={InviteInfoRow}>
                    <FriendWrapper src={AddFriendA} />
                    <div style={RewardWrapperBigText}>You have invited {userData && teamSize != null ? teamSize.toFixed(0) : "?"} friend(s)! </div>
                </div>
                <div style={ButtonRow}>
                
                    <button style={ButtonC} onClick={handleGenerateLink}>
                        <div style={ButtonTextC}>Get Invite Link</div>
                    </button>
                
                </div>
            </div>         
            </HeroSection>
            
            {isModalOpen && (
                
                    <motion.div 
                            initial={{ y: "100%" }} 
                            animate={{ y: "0%" }} 
                            transition={{ duration: 0.5, ease: "easeInOut" }}
                            style={{
                                position: "fixed",
                                top: "25%",
                                width: "80%",
                                height: "auto",
                                background: "#eee",
                                borderRadius: "10px",
                                boxShadow: "0 -4px 10px rgba(0, 0, 0, 0.2)",
                                display: "flex",
                                flexDirection: 'column',
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: "999",
                            }}
                            onClick={() => setModalOpen(false)}
                        >
                            <IconImage src={COPIEDICON} />
                        <ModalTopTitle>Your invite link has been copied to the clipboard!</ModalTopTitle>
                        <a href={userInviteLink} target="_blank" rel="noopener noreferrer">
                            {userInviteLink}
                        </a>
                    </motion.div>
                
            )}
            <Footer />
        </Container>
    );
};

export default Invite;
